
class SnippetHandler extends EventTarget {
    constructor(naja) {
        super();
        this.op = {
            replace: {
                updateElement(snippet, content) {
                    snippet.innerHTML = content;
                },
                updateIndex(_, newContent) {
                    return newContent;
                },
            },
            prepend: {
                updateElement(snippet, content) {
                    snippet.insertAdjacentHTML('afterbegin', content);
                },
                updateIndex(currentContent, newContent) {
                    return newContent + currentContent;
                },
            },
            append: {
                updateElement(snippet, content) {
                    snippet.insertAdjacentHTML('beforeend', content);
                },
                updateIndex(currentContent, newContent) {
                    return currentContent + newContent;
                },
            },
        };
        naja.addEventListener('success', (event) => {
            const { options, payload } = event.detail;
            if (!payload.snippets) {
                return;
            }
            this.updateSnippets(payload.snippets, false, options);
        });
    }
    static findSnippets(predicate, document = window.document) {
        const result = {};
        const snippets = document.querySelectorAll('[id^="snippet-"]');
        snippets.forEach((snippet) => {
            if (predicate?.(snippet) ?? true) {
                result[snippet.id] = snippet.innerHTML;
            }
        });
        return result;
    }
    async updateSnippets(snippets, fromCache = false, options = {}) {
        await Promise.all(Object.keys(snippets).map(async (id) => {
            const snippet = document.getElementById(id);
            if (snippet) {
                await this.updateSnippet(snippet, snippets[id], fromCache, options);
            }
        }));
    }
    async updateSnippet(snippet, content, fromCache, options) {
        let operation = this.op.replace;
        if ((snippet.hasAttribute('data-naja-snippet-prepend') || snippet.hasAttribute('data-ajax-prepend')) || options.payload?.prepend === snippet.id && !fromCache) {
            operation = this.op.prepend;
        }
        else if ((snippet.hasAttribute('data-naja-snippet-append') || snippet.hasAttribute('data-ajax-append')) || options.payload?.prepend === snippet.id && !fromCache) {
            operation = this.op.append;
        }
        const canUpdate = this.dispatchEvent(new CustomEvent('beforeUpdate', {
            cancelable: true,
            detail: {
                snippet,
                content,
                fromCache,
                operation,
                changeOperation(value) {
                    operation = value;
                },
                options,
            },
        }));
        if (!canUpdate) {
            return;
        }
        this.dispatchEvent(new CustomEvent('pendingUpdate', {
            detail: {
                snippet,
                content,
                fromCache,
                operation,
                options,
            },
        }));
        const updateElement = typeof operation === 'function' ? operation : operation.updateElement;
        await updateElement(snippet, content);
        this.dispatchEvent(new CustomEvent('afterUpdate', {
            detail: {
                snippet,
                content,
                fromCache,
                operation,
                options,
            },
        }));
    }
}
